var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingGoodActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_2044_1155)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 40.4996C20.9426 40.5085 17.9433 39.664 15.3397 38.0612C12.736 36.4584 10.6313 34.1609 9.26222 31.4271C9.08291 31.072 9.052 30.6603 9.17629 30.2824C9.30059 29.9045 9.5699 29.5915 9.92499 29.4122C10.2801 29.2329 10.6918 29.202 11.0697 29.3263C11.4476 29.4506 11.7606 29.7199 11.9399 30.075C13.0659 32.3075 14.7894 34.1836 16.9186 35.4945C19.0478 36.8053 21.499 37.4994 23.9994 37.4995C26.4998 37.4996 28.9511 36.8056 31.0803 35.4949C33.2096 34.1842 34.9333 32.3081 36.0593 30.0757C36.1477 29.8991 36.27 29.7417 36.4193 29.6125C36.5686 29.4833 36.7419 29.3849 36.9294 29.3228C37.1168 29.2608 37.3146 29.2363 37.5115 29.2509C37.7084 29.2655 37.9005 29.3188 38.0768 29.4078C38.253 29.4968 38.41 29.6197 38.5386 29.7695C38.6672 29.9193 38.765 30.093 38.8264 30.2807C38.8877 30.4683 38.9114 30.6663 38.8961 30.8631C38.8808 31.0599 38.8267 31.2518 38.7371 31.4277C37.3678 34.1612 35.2631 36.4584 32.6597 38.0611C30.0562 39.6638 27.0572 40.5083 24 40.4996Z",
    fill: "#2C4866"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.625C39 15.1397 36.9853 13.125 34.5 13.125C32.0147 13.125 30 15.1397 30 17.625V20.625C30 23.1103 32.0147 25.125 34.5 25.125C36.9853 25.125 39 23.1103 39 20.625V17.625Z",
    fill: "url(#paint1_linear_2044_1155)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 19.125C36.6605 19.125 37.5 18.2855 37.5 17.25C37.5 16.2145 36.6605 15.375 35.625 15.375C34.5895 15.375 33.75 16.2145 33.75 17.25C33.75 18.2855 34.5895 19.125 35.625 19.125Z",
    fill: "#FFEFDC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.625C18 15.1397 15.9853 13.125 13.5 13.125C11.0147 13.125 9 15.1397 9 17.625V20.625C9 23.1103 11.0147 25.125 13.5 25.125C15.9853 25.125 18 23.1103 18 20.625V17.625Z",
    fill: "url(#paint2_linear_2044_1155)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 19.125C15.6605 19.125 16.5 18.2855 16.5 17.25C16.5 16.2145 15.6605 15.375 14.625 15.375C13.5895 15.375 12.75 16.2145 12.75 17.25C12.75 18.2855 13.5895 19.125 14.625 19.125Z",
    fill: "#FFEFDC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2044_1155",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0702,
    stopColor: "#FFCD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2689,
    stopColor: "#FFC037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4806,
    stopColor: "#FFB726"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7119,
    stopColor: "#FFB21C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2044_1155",
    x1: 30.568,
    y1: 15.193,
    x2: 38.432,
    y2: 23.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142F47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2044_1155",
    x1: 9.56802,
    y1: 15.193,
    x2: 17.432,
    y2: 23.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#334E66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#142F47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingGoodActive);
export default __webpack_public_path__ + "static/media/rating_good_active.e79b0438790ace4d98ef1e250490a9cc.svg";
export { ForwardRef as ReactComponent };